import { useState, useCallback, useEffect } from "react";
import { IArquivoCardEsteira } from "../../interfaces/IArquivoCardEsteira";
import { IArquivoCard } from "../../interfaces/IArquivoCard";
import RelatoriosService from "../../services/RelatoriosService";
import ConstanciaService from "../../services/ConstanciaService";
import { IConstanciaResumo } from "../../interfaces/IConstancia";
import Swal from "sweetalert2";
import ArquivoEmpresaService from "../../services/ArquivoEmpresaService";
import { uniqueId } from "lodash";
import { Modal } from 'react-bootstrap-v5';
import { IEntries, ILancamento, IRelatorio } from "../../interfaces/IRelatorio";
import ReactS3Client from "react-aws-s3-typescript";
import { configBucket } from "../../utils/S3Utils";
import ParametrizacaoService from "../../services/ParametrizacaoService";
import moment from "moment";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import EmpresasService from "../../services/EmpresasService";
import ArquivoCardEsteiraService from "../../services/ArquivoCardEsteiraService";
import DropdownList from "react-widgets/DropdownList";
import { groupBy } from '../../utils/Array';
import ReactHtmlParser from 'react-html-parser';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import lancamentoNovaService from "../../services/lancamentoNovaService";

/*Tradução */
import '../../../i18n/config';
import { useTranslation } from 'react-i18next';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top' as const,
        },
        title: {
            display: true,
            text: 'Variância de valores mensal',
        },
    },
};

const statusObject: any = {
    'totalpendente': 'SOLICITAÇÕES DE ALTERAÇÃO',
}

function ModalConciliacao({ toggleModal, show, item }: { toggleModal: () => void, show: boolean, item: IEntries }) {


    const [loading, setLoading] = useState<boolean>(false);
    const [loaded, setLoaded] = useState<boolean>(false);
    const [possiveisMatch, setPossiveisMatch] = useState<ILancamento[]>([]);
    const { t } = useTranslation();
    const onConciliar = useCallback((entry: ILancamento) => {
        EmpresasService.conciliarLancamentos([item.id, entry.id || 0]).then((resp) => {
            Swal.fire({
                text: t('Lançamentos conciliados com sucesso'),
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });

            toggleModal();
        });
    }, [item, toggleModal]);

    const buscarPossiveisMatch = useCallback((item) => {
        RelatoriosService.buscarPossivelMatch(item.id).then((resp) => {
            setPossiveisMatch(resp);
            setLoading(false);
            setLoaded(true);
        });
    }, [])

    useEffect(() => {
        if (!loaded && !loading) {
            setLoading(true);
            buscarPossiveisMatch(item);
        }
    }, [loading, item, buscarPossiveisMatch]);

    useEffect(() => {
        if (!show) {
            setLoaded(false);
        }
    }, [show])


    return (
        <Modal size='lg' centered={true} show={show} onHide={toggleModal}>
            <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                <div className="modal-header">
                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                        <i onClick={toggleModal} className="fas fa-arrow-left" style={{ color: '#5E6397' }}></i>
                    </div>
                    <h5 className="modal-title titulo-modal" style={{ textTransform: 'uppercase' }}>{t('Conciliação Inteligente')}</h5>
                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                        <i onClick={toggleModal} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                    </div>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-md-12">
                            {loading && <label>Carregando...</label>}
                            {(!possiveisMatch || possiveisMatch.length === 0) && !loading && (
                                <label>Não foi encontrado nenhum lançamento</label>
                            )}
                            {possiveisMatch && possiveisMatch.length > 0 && !loading && (
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col">Conta</th>
                                            <th scope="col">Descrição</th>
                                            <th scope="col">Data</th>
                                            <th scope="col">Valor</th>
                                            <th scope="col">Histórico</th>
                                            <th scope="col">Tipo Lançamento</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {possiveisMatch.map((item) => (
                                            <tr key={uniqueId()}>
                                                <th>{item.codigoContabil}</th>
                                                <th>{item.descricaoCodigoContabil}</th>
                                                <th scope="row">{moment(item.dataLancamento).format('DD/MM/YYYY')}</th>
                                                <td>{item?.valorProvisaoRecolher?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                                <td>{item.historico}</td>
                                                <td>{item.tipoLancamento}</td>
                                                <td><button className="btn btn-danger" onClick={() => {
                                                    setLoading(true);
                                                    onConciliar(item);
                                                }}>Conciliar</button></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

function RelatorioDemonstracaoContas({ contas, toggleModal, show, id, status, esteiraID }: { contas: IRelatorio[], toggleModal: () => void, show: boolean, id: number, status: string, esteiraID: number }) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(false);
    const [modalAlterar, setModalAlterar] = useState<boolean>(false);
    const [item, setItem] = useState<IEntries[]>([]);
    const [data, setData] = useState<IEntries[]>([]);
    const [lancamentosSelecionados, setLancamentosSelecionados] = useState<number[]>([]);
    const [lancamentosPendentes, setLancamentosPendentes] = useState<Set<number>>(new Set());

    const loadData = useCallback((offset) => {
        RelatoriosService.dadosResumidosPorStatusInterno(esteiraID, id, offset, status === "conciliacao" ? "totalpendente" : status, '', false, (result) => {
            setData((old) => {
                if (offset > 0) {
                    const oldObjFake = old || [];
                    const oldObj = [...oldObjFake];
                    return oldObj.concat(result);
                }

                return result;
            });

            if (result && result.length > 0) {
                setTimeout(() => {
                    loadData(offset + result.length);
                }, 2000)
            } else {
                setLoading(false);
            }
        });
    }, [esteiraID, id, status]);

    const carregarPendentes = useCallback(() => {
        if (status !== 'totalpendente') return;
        ArquivoCardEsteiraService.buscarAlteracoesPendentesNova(esteiraID)
            .then((pendentes) => setLancamentosPendentes(new Set(pendentes.map(p => p.lancamentoId))))
            .catch(() => setLancamentosPendentes(new Set()));
    }, [esteiraID, status]);


    const onDesvincularStatus = useCallback((id) => {

        setLoading(true);
        Swal.fire({
            title: 'Deseja desvincular o status ?',
            showDenyButton: true,
            showConfirmButton: true,
            confirmButtonColor: 'green',
            cancelButtonColor: 'red',
            confirmButtonText: 'Sim',
            denyButtonText: `Não`,
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await lancamentoNovaService.desvincularStatus(id);
                    Swal.fire({
                        text: t('Status desvinculado com sucesso.'),
                        timer: 3000,
                        icon: 'success',
                        showConfirmButton: false
                    });
                    setData((old) => {
                        const copy = [...old];
                        return copy.filter(f => f.id !== id);
                    });
                } catch (e: any) {
                    Swal.fire({
                        text: t('Ocorreu um erro inesperado.'),
                        timer: 3000,
                        icon: 'error',
                        showConfirmButton: false
                    });
                }
                setLoading(false);
            } else {
                setLoading(false);
            }
        });

    }, [loadData, id]);

    const onSelect = useCallback((e: any, acc: number[]) => {
        if (e) {
            setLancamentosSelecionados((old) => {
                return acc;
            })
        } else {
            setLancamentosSelecionados((old) => {
                return [];
            });
        }
    }, []);

    const onAlterar = useCallback((item: IEntries) => {
        setItem([item]);
        setModalAlterar(true);
    }, []);

    const onAlterarSelecionados = useCallback(() => {
        const itens = data.filter(i => lancamentosSelecionados.includes(i.id));
        setItem(itens);
        setModalAlterar(true);
    }, [data, lancamentosSelecionados]);

    const onBuscarLancamentos = useCallback((item: IEntries) => {
        setItem([item]);
        setModalAlterar(true);
    }, []);

    const exportExcel = useCallback(() => {
        if (data) {
            const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            const fileExtension = ".xlsx";
            const ws = XLSX.utils.json_to_sheet(data.map((i) => {
                let obj = {
                    "Conta": i.codigoContabil,
                    "Data do Lançamento": moment(i.dataLancamento).format('DD/MM/YYYY'),
                    "Valor": i.valorProvisaoRecolher.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }),
                    "Histórico": i.historico,
                    "Tipo do Lançamento": i.tipoLancamento,
                } as any;

                if (status === "conciliacao") {
                    obj["Código Contábil"] = i.codigoContabil;
                }

                if (status === "erro" || status === "aviso" || status === "recomendacao" || status === "pendente") {
                    obj["Erro"] = i.mensagem && i.mensagem.descricaoMensagem;
                    obj["Recomendação"] = i.mensagem && i.mensagem.recomendacaoAjuste;
                }

                if (status === "conciliado") {
                    obj["Chave Vínculo"] = i.chaveVinculo;
                }

                return obj;
            }));
            const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            const dataF = new Blob([excelBuffer], { type: fileType });
            saveAs(dataF, `Relatorio-${Date.now()}` + fileExtension);
        }
    }, [data, status]);

    useEffect(() => {
        if (show) {
            setData([]);
            setLoading(true);
            loadData(0);
            carregarPendentes();
        }
    }, [show, loadData, carregarPendentes]);

    return (
        <>
            <Modal scrollable size={status === 'totalpendente' ? 'xl' : 'lg'} centered={true} show={!show || modalAlterar ? false : true} onHide={toggleModal}>
                <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                    <div className="modal-header">
                        <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                            <i onClick={toggleModal} className="fas fa-arrow-left" style={{ color: '#5E6397' }}></i>
                        </div>
                        <h5 className="modal-title titulo-modal" style={{ textTransform: 'uppercase' }}>{statusObject[status]}</h5>
                        <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                            <i onClick={toggleModal} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                        </div>
                    </div>
                    <div className="modal-body">
                        <div className="row g-3">
                            {data && data.length > 0 && (
                                <div className="col-12 d-flex align-items-center justify-content-between">
                                    <span className="text-muted fs-7">
                                        {data.length} {t("lançamento(s) encontrado(s)")}
                                    </span>
                                    <button type="button" className='btn btn-sm btn-light-success' onClick={exportExcel}>
                                        <i className="fas fa-file-excel me-1" />
                                        {t("Exportar Excel")}
                                    </button>
                                </div>
                            )}

                            {data && data.length > 0 && !loading && status === 'totalpendente' && (
                                <div className="col-12">
                                    <div className="d-flex align-items-center gap-3 p-3 bg-light rounded">
                                        <div className="form-check mb-0">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="selectAll"
                                                checked={data.length === lancamentosSelecionados.length && data.length > 0}
                                                onChange={(e) => onSelect(e.target.checked, data.map(i => i.id))}
                                            />
                                            <label className="form-check-label fw-semibold" htmlFor="selectAll">
                                                {t("Selecionar todos")}
                                            </label>
                                        </div>
                                        {lancamentosSelecionados.length > 0 && (
                                            <>
                                                <span className="badge badge-light-primary fs-7">
                                                    {lancamentosSelecionados.length} {t("selecionado(s)")}
                                                </span>
                                                <button
                                                    onClick={onAlterarSelecionados}
                                                    type='button'
                                                    className="btn btn-sm btn-primary"
                                                >
                                                    <i className="fas fa-edit me-1" />
                                                    {t("Solicitar Alteração em Massa")}
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}

                            <div className="col-12">
                                {loading && (
                                    <div className="d-flex align-items-center gap-2 text-muted py-4 justify-content-center">
                                        <span className="spinner-border spinner-border-sm" />
                                        <span>{t("Carregando lançamentos...")}</span>
                                    </div>
                                )}
                                {(!data || data.length === 0) && !loading && (
                                    <div className="text-center text-muted py-8">
                                        <i className="fas fa-inbox fs-2x mb-3 d-block opacity-50" />
                                        <span>{t("Nenhum lançamento encontrado")}</span>
                                    </div>
                                )}
                                {data.length > 0 && (
                                    <table className="table table-hover table-sm align-middle">
                                        <thead className="table-light">
                                            <tr>
                                                {status === 'totalpendente' && <th style={{ width: 40 }}></th>}
                                                {status === "conciliacao" && <th scope="col">{t("Conta")}</th>}
                                                <th scope="col">{t("Data")}</th>
                                                <th scope="col">{t("Valor")}</th>
                                                <th scope="col">{t("Histórico")}</th>
                                                <th scope="col">{t("Tipo")}</th>
                                                {(status === "erro" || status === "aviso" || status === "recomendacao" || status === "pendente") && (
                                                    <>
                                                        <th scope="col">{t("Erro")}</th>
                                                        <th scope="col">{t("Recomendação")}</th>
                                                    </>
                                                )}
                                                {status === "conciliado" && (
                                                    <th scope="col">{t("Chave Vínculo")}</th>
                                                )}
                                                {(status === "totalpendente" || status === "conciliacao") && (
                                                    <th style={{ width: 160 }}></th>
                                                )}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.map((item) => (
                                                <tr key={uniqueId()}>
                                                    {status === 'totalpendente' && (
                                                        <td>
                                                            <div className="form-check d-flex justify-content-center mb-0">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    checked={lancamentosSelecionados.includes(item.id)}
                                                                    onChange={(e) => onSelect(e.target.checked, [item.id])}
                                                                />
                                                            </div>
                                                        </td>
                                                    )}
                                                    {status === "conciliacao" && <td>{item.codigoContabil}</td>}
                                                    <td className="text-nowrap">{moment(item.dataLancamento).format('DD/MM/YYYY')}</td>
                                                    <td className="text-nowrap fw-semibold">{item.valorProvisaoRecolher.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                                    <td className="text-truncate" style={{ maxWidth: 200 }} title={item.historico}>{item.historico}</td>
                                                    <td><span className="badge badge-light-info">{item.tipoLancamento}</span></td>
                                                    {(status === "erro" || status === "aviso" || status === "recomendacao" || status === "pendente") && (
                                                        <>
                                                            <td>{item.mensagem && item.mensagem.descricaoMensagem}</td>
                                                            <td>{item.mensagem && item.mensagem.recomendacaoAjuste}</td>
                                                        </>
                                                    )}
                                                    {status === "conciliado" && (
                                                        <td>{item.chaveVinculo}</td>
                                                    )}
                                                    {status === "totalpendente" && (
                                                        <td>
                                                            {item.status === 'PENDENTESALDOANTERIOR' ? (
                                                                <button onClick={() => onDesvincularStatus(item.id)} type='button' className="btn btn-sm btn-light-warning">
                                                                    <i className="fas fa-unlink me-1" />
                                                                    {t("Desvincular")}
                                                                </button>
                                                            ) : lancamentosPendentes.has(item.id) ? (
                                                                <span title={t("Já existe uma alteração aguardando aprovação para este lançamento")}>
                                                                    <button type='button' className="btn btn-sm btn-secondary" disabled>
                                                                        <i className="fas fa-clock me-1" />
                                                                        {t("Aguardando aprovação")}
                                                                    </button>
                                                                </span>
                                                            ) : (
                                                                <button onClick={() => onAlterar(item)} type='button' className="btn btn-sm btn-light-primary">
                                                                    <i className="fas fa-edit me-1" />
                                                                    {t("Solicitar Alteração")}
                                                                </button>
                                                            )}
                                                        </td>
                                                    )}
                                                    {status === "conciliacao" && (
                                                        <td>
                                                            <button className="btn btn-sm btn-light-primary" onClick={() => onBuscarLancamentos(item)}>
                                                                <i className="fas fa-search me-1" />
                                                                {t("Buscar")}
                                                            </button>
                                                        </td>
                                                    )}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            {item.length > 0 && status !== "conciliacao" && (
                <ModalAlterarLancamento esteiraID={esteiraID} contas={contas} show={modalAlterar} item={item} toggleModal={() => {
                    setModalAlterar(false);
                    setLoading(true);
                    loadData(0);
                    carregarPendentes();
                }} />
            )}
            {item.length > 0 && status === "conciliacao" && (
                <ModalConciliacao show={modalAlterar} item={item[0]} toggleModal={() => {
                    setModalAlterar(false);
                    setLoading(true);
                    loadData(0);
                }} />
            )}
        </>
    )
}



function ModalAlterarLancamento({ contas, esteiraID, toggleModal, show, item }: { esteiraID: number, contas: IRelatorio[], toggleModal: () => void, show: boolean, item: IEntries[] }) {
    const { t } = useTranslation();
    const isBulk = item.length > 1;
    const [tipo, setTipo] = useState<string>(isBulk ? 'CONTA' : '');
    const [contaSelecionada, setContaSelecionada] = useState<string>('');
    const [textoHistorico, setTextoHistorico] = useState<string>(item[0].historico);
    const [valor, setValor] = useState<string>(item[0].valorProvisaoRecolher.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "").trim());

    const onSubmit = useCallback(async () => {
        if (!tipo) return;

        try {
            switch (tipo) {
                case 'HISTORICO':
                    if (!textoHistorico) {
                        Swal.fire({ text: t('Por favor forneça um novo histórico'), timer: 3000, icon: 'error', showConfirmButton: false });
                        return;
                    }
                    if (item[0].historico === textoHistorico) {
                        Swal.fire({ text: t('Para alterar o histórico é necessário que ele seja diferente do histórico anterior'), timer: 3000, icon: 'error', showConfirmButton: false });
                        return;
                    }
                    await ArquivoCardEsteiraService.alterarHistorico(item[0].id, textoHistorico, esteiraID);
                    break;

                case 'VALOR': {
                    if (!valor) {
                        Swal.fire({ text: t('Por favor digite um novo valor'), timer: 3000, icon: 'error', showConfirmButton: false });
                        return;
                    }
                    const valorLimpo = valor.replace(".", "").replace(",", ".");
                    const novoValor = Number(valorLimpo);
                    if (item[0].valorProvisaoRecolher === novoValor) {
                        Swal.fire({ text: t('Para alterar o valor é necessário que ele seja diferente do valor anterior'), timer: 3000, icon: 'error', showConfirmButton: false });
                        return;
                    }
                    await ArquivoCardEsteiraService.alterarValor(item[0].id, valorLimpo, esteiraID);
                    break;
                }

                case 'CONTA':
                    if (!contaSelecionada) {
                        Swal.fire({ text: t('Para alterar a conta é necessário selecionar uma opção.'), timer: 3000, icon: 'error', showConfirmButton: false });
                        return;
                    }
                    if (isBulk) {
                        await ArquivoCardEsteiraService.solicitarAlteracaoLote(esteiraID, item.map(i => i.id), contaSelecionada);
                    } else {
                        await ArquivoCardEsteiraService.alterarConta([{ lancamentoID: item[0].id, conta: contaSelecionada, esteiraId: esteiraID }]);
                    }
                    break;

                case 'ESTORNO':
                    await ArquivoCardEsteiraService.alterarEstorno(item[0].id, esteiraID);
                    break;

                default:
                    return;
            }

            Swal.fire({ text: t('Inserimos sua solicitação para aprovação do fiscal contábil, após aprovada suas alterações serão refletidas em seu lançamento'), timer: 3000, icon: 'success', showConfirmButton: false });
            toggleModal();
        } catch (e: any) {
            const msg = e?.response?.data?.message || e?.message || t('Ocorreu um erro ao processar a solicitação.');
            Swal.fire({ text: msg, timer: 5000, icon: 'error', showConfirmButton: false });
        }
    }, [tipo, textoHistorico, valor, contaSelecionada, item, esteiraID, isBulk, toggleModal]);

    useEffect(() => {
        setValor(item[0].valorProvisaoRecolher.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "").trim());
        setTextoHistorico(item[0].historico);
        setContaSelecionada('');
        setTipo(isBulk ? 'CONTA' : '');
    }, [item, isBulk]);

    return (
        <Modal size='lg' centered={true} show={show} onHide={toggleModal}>
            <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                <div className="modal-header">
                    <h5 className="modal-title titulo-modal" style={{ textTransform: 'uppercase' }}>Ajuste de Lançamento{isBulk ? 's' : ''}</h5>
                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                        <i onClick={toggleModal} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                    </div>
                </div>
                <div className="modal-body">
                    <div className="row">
                        {!isBulk && (
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>Tipo de alteração</label>
                                    <select className="form-control mt-1" value={tipo} onChange={(e) => { setTipo(e.target.value); setContaSelecionada(''); }}>
                                        <option value="">Selecione um tipo...</option>
                                        <option value="CONTA">Conta</option>
                                        <option value="HISTORICO">Histórico</option>
                                        <option value="VALOR">Valor</option>
                                        <option value="ESTORNO">Estorno</option>
                                    </select>
                                </div>
                            </div>
                        )}

                        <div className="col-md-12 mt-2">
                            <div className="form-group">
                                <label>Conta de destino</label>
                                <DropdownList
                                    disabled={tipo !== 'CONTA'}
                                    onChange={(e) => setContaSelecionada(e.split('-')[0].trim())}
                                    defaultValue="Selecione um tipo..."
                                    filter='contains'
                                    data={["Selecione um tipo...", ...contas.filter(f => f.contaEmpresa !== contaSelecionada).map((item) => `${item.contaEmpresa} - ${item.descricaoEmpresa}`)]}
                                />
                            </div>
                        </div>

                        {!isBulk && (
                            <>
                                <div className="col-md-12 mt-2">
                                    <div className="form-group">
                                        <label>Novo histórico</label>
                                        <input
                                            className='form-control mt-1'
                                            value={textoHistorico}
                                            onChange={(e) => setTextoHistorico(e.target.value)}
                                            disabled={tipo !== 'HISTORICO'}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-12 mt-2">
                                    <div className="form-group">
                                        <label>Novo valor</label>
                                        <input
                                            className='form-control mt-1'
                                            type="text"
                                            value={valor}
                                            disabled={tipo !== 'VALOR'}
                                            onChange={(e) => {
                                                if (tipo !== 'VALOR') return;
                                                let value = e.target.value;
                                                if (!value) {
                                                    setValor(Number(0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "").trim());
                                                } else {
                                                    value = parseInt(value.replace(/[\D]+/g, '')).toString();
                                                    value = value.replace(/([0-9]{2})$/g, ",$1");
                                                    if (value.length > 6) {
                                                        value = value.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
                                                    }
                                                    setValor(value);
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </>
                        )}

                        <div className="col-md-12 mt-4">
                            <button type="button" onClick={onSubmit} disabled={!tipo} className="btn btn-success">SOLICITAR</button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}


function RelatorioDemonstracaoContasConfirmacao({ id, toggleModal, show, acc, esteiraID }: { id: number, toggleModal: () => void, show: boolean, acc: string, esteiraID: number }) {

    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<IEntries[]>([]);

    const loadData = useCallback((offset) => {
        RelatoriosService.dadosResumidosPorStatusInterno(esteiraID, id, offset, 'totalmatch', '', false, (result) => {
            setData((old) => {
                if (offset > 0) {
                    const oldObjFake = old || [];
                    const oldObj = [...oldObjFake];
                    return oldObj.concat(result);
                }

                return result;
            });

            if (result && result.length > 0) {
                setTimeout(() => {
                    loadData(offset + result.length);
                }, 2000)
            } else {
                setLoading(false);
            }
        });
    }, [esteiraID, id]);

    const onClickRecusar = useCallback((chaveVinculo?: string) => {
        if (chaveVinculo) {
            Swal.fire({
                title: 'Você gostaria de recusar a conciliação ?',
                showDenyButton: true,
                showConfirmButton: true,
                confirmButtonColor: 'green',
                cancelButtonColor: 'red',
                confirmButtonText: 'Sim',
                denyButtonText: `Não`,
            }).then((result) => {
                if (result.isConfirmed) {
                    setData((old) => {
                        const allKey = old.filter((i) => i.chaveVinculo === chaveVinculo).map(i => i.id);
                        EmpresasService.desvincularMatch(esteiraID, id, [chaveVinculo]);
                        return old.filter(i => !allKey.includes(i.id));
                    });
                }
            });
        } else {
            Swal.fire({
                title: 'Você gostaria de recusar todas as conciliações ?',
                showDenyButton: true,
                showConfirmButton: true,
                confirmButtonColor: 'green',
                cancelButtonColor: 'red',
                confirmButtonText: 'Sim',
                denyButtonText: `Não`,
            }).then((result) => {
                if (result.isConfirmed) {
                    setData((old) => {
                        const allKeys = Object.keys(groupBy(old, 'chaveVinculo'));
                        EmpresasService.desvincularMatch(esteiraID, id, []);
                        return [];
                    });
                }
            });
        }
    }, [esteiraID, acc, id]);

    const onClickAceitar = useCallback((chaveVinculo?: String) => {
        if (chaveVinculo) {
            Swal.fire({
                title: 'Você aceita a conciliação ?',
                showDenyButton: true,
                showConfirmButton: true,
                confirmButtonColor: 'green',
                cancelButtonColor: 'red',
                confirmButtonText: 'Sim',
                denyButtonText: `Não`,
            }).then((result) => {
                if (result.isConfirmed) {
                    setData((old) => {
                        const allKey = old.filter((i) => i.chaveVinculo === chaveVinculo).map(i => i.id);
                        EmpresasService.conciliarLancamentos(allKey);
                        return old.filter(i => !allKey.includes(i.id));
                    });
                }
            });
        } else {
            Swal.fire({
                title: 'Você aceita conciliar todos ?',
                showDenyButton: true,
                showConfirmButton: true,
                confirmButtonColor: 'green',
                cancelButtonColor: 'red',
                confirmButtonText: 'Sim',
                denyButtonText: `Não`,
            }).then((result) => {
                if (result.isConfirmed) {
                    setData((old) => {
                        const allKeys = Object.keys(groupBy(old, 'chaveVinculo'));
                        allKeys.forEach((item) => {
                            EmpresasService.conciliarLancamentos(old.filter(i => i.chaveVinculo === item).map(i => i.id));
                        });
                        return [];
                    });
                }
            });
        }
    }, [esteiraID, acc]);


    useEffect(() => {
        if (show) {
            setLoading(true);
            loadData(0);
        }
    }, [show, loadData]);

    return (
        <Modal size='lg' centered={true} show={show} onHide={toggleModal}>
            <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                <div className="modal-header">
                    <h5 className="modal-title titulo-modal" style={{ textTransform: 'uppercase' }}>Confirmação de Conciliação</h5>
                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                        <i onClick={toggleModal} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                    </div>
                </div>
                <div className="modal-body">
                    <div className="row">
                        {data && data.length > 0 && !loading && (
                            <div className='col-md-12'>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <button type="button" style={{ width: '26%' }} onClick={() => onClickAceitar()} className="btn btn-success">Aceitar Todos</button>
                                    </div>
                                    <div className='col-md-12 mt-4'>
                                        <button type="button" style={{ width: '26%' }} onClick={() => onClickRecusar()} className="btn btn-danger">Recusar Todos</button>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="col-md-12">
                            {loading && <label>Carregando...</label>}
                            {(!data || data.length === 0) && !loading && (
                                <label>Não foi encontrado nenhum lançamento</label>
                            )}
                            {data && data.length > 0 && !loading && (
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.keys(groupBy(data, 'chaveVinculo')).map((item) => (
                                            <>
                                                <tr key={uniqueId()}>
                                                    <th scope="row"><button type="button" onClick={() => onClickAceitar(item)} className="btn btn-success">Aceitar</button></th>
                                                    <th scope="row"><button type="button" onClick={() => onClickRecusar(item)} className="btn btn-danger">Recusar</button></th>
                                                    <th scope="row">
                                                        <tr>
                                                            <table className="table table-striped">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">Data Lançamento</th>
                                                                        <th>Histórico</th>
                                                                        <th>Tipo</th>
                                                                        <th>Valor</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {data.filter(f => f.chaveVinculo === item).map((item) => (
                                                                        <>
                                                                            <tr key={uniqueId()}>
                                                                                <th scope="row">{moment(item.dataLancamento).format('DD/MM/YYYY')}</th>
                                                                                <th>{item.historico}</th>
                                                                                <th>{item.tipoLancamento}</th>
                                                                                <th>{item.valorProvisaoRecolher.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</th>
                                                                            </tr>
                                                                        </>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </tr>
                                                    </th>
                                                </tr>
                                                <tr style={{ border: 'none' }}>
                                                    <th></th>
                                                    <th></th>
                                                    <th>
                                                        <label>Total Débito: {data && data.filter(f => f.chaveVinculo === item && f.tipoLancamento === 'D').length > 0 ? data.filter(f => f.chaveVinculo === item && f.tipoLancamento === 'D').map(m => m.valorProvisaoRecolher).reduce((a, b) => a + b).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : 'R$ 0,00'} </label>
                                                    </th>
                                                </tr>
                                                <tr style={{ border: 'none' }}>
                                                    <th></th>
                                                    <th></th>
                                                    <th>
                                                        <label>Total Crédito: {data && data.filter(f => f.chaveVinculo === item && f.tipoLancamento === 'C').length > 0 ? data.filter(f => f.chaveVinculo === item && f.tipoLancamento === 'C').map(m => m.valorProvisaoRecolher).reduce((a, b) => a + b).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : 'R$ 0,00'}</label>
                                                    </th>
                                                </tr>
                                                <tr style={{ border: 'none' }}>
                                                    <th></th>
                                                    <th></th>
                                                    <th><label>Diferença: {Math.abs((data.filter(f => f.chaveVinculo === item && f.tipoLancamento === 'C').length > 0 ? data.filter(f => f.chaveVinculo === item && f.tipoLancamento === 'C').map(m => m.valorProvisaoRecolher).reduce((a, b) => a + b) : 0) - (data.filter(f => f.chaveVinculo === item && f.tipoLancamento === 'D').length > 0 ? data.filter(f => f.chaveVinculo === item && f.tipoLancamento === 'D').map(m => m.valorProvisaoRecolher).reduce((a, b) => a + b) : 0)).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</label></th>
                                                </tr>
                                            </>
                                        ))}
                                        <tr>
                                            <th scope="row">Total: {data.length}</th>
                                        </tr>
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

function RelatorioDemonstracaoContasConciliadas({ id, toggleModal, show, acc, esteiraID }: { id: number, toggleModal: () => void, show: boolean, acc: string, esteiraID: number }) {

    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<IEntries[]>([]);

    const loadData = useCallback((offset) => {
        RelatoriosService.dadosResumidosPorStatusInterno(esteiraID, id, offset, 'conciliado', '', false, (result) => {
            setData((old) => {
                if (offset > 0) {
                    const oldObjFake = old || [];
                    const oldObj = [...oldObjFake];
                    return oldObj.concat(result);
                }

                return result;
            });

            if (result && result.length > 0) {
                setTimeout(() => {
                    loadData(offset + result.length);
                }, 2000)
            } else {
                setLoading(false);
            }
        });
    }, [esteiraID, id]);

    const onClickDesvincularTodos = useCallback((chaves: string[]) => {
        Swal.fire({
            title: 'Você gostaria de desvincular todos lançamentos ?',
            showDenyButton: true,
            showConfirmButton: true,
            confirmButtonColor: 'green',
            cancelButtonColor: 'red',
            confirmButtonText: 'Sim',
            denyButtonText: `Não`,
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                chaves.forEach((chaveVinculo) => {
                    setData((old) => {
                        const copy = [...old];
                        return copy.filter((item) => item.chaveVinculo !== chaveVinculo);
                    });
                    ParametrizacaoService.desvincular(id, chaveVinculo);
                });
                setLoading(false);
            }
        });
    }, [esteiraID, acc, id]);

    const onClickDesvincular = useCallback((chaveVinculo: string) => {
        Swal.fire({
            title: 'Você gostaria de desvincular ?',
            showDenyButton: true,
            showConfirmButton: true,
            confirmButtonColor: 'green',
            cancelButtonColor: 'red',
            confirmButtonText: 'Sim',
            denyButtonText: `Não`,
        }).then((result) => {
            if (result.isConfirmed) {
                setData((old) => {
                    const copy = [...old];
                    return copy.filter((item) => item.chaveVinculo !== chaveVinculo);
                });
                ParametrizacaoService.desvincular(id, chaveVinculo);
            }
        });
    }, [esteiraID, acc, id]);

    const exportExcel = useCallback(() => {
        if (data) {
            const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            const fileExtension = ".xlsx";
            const ws = XLSX.utils.json_to_sheet(data.map((i) => {
                let obj = {
                    "Conta": i.codigoContabil,
                    "Data do Lançamento": moment(i.dataLancamento).format('DD/MM/YYYY'),
                    "Valor": i.valorProvisaoRecolher.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }),
                    "Histórico": i.historico,
                    "Tipo do Lançamento": i.tipoLancamento,
                } as any;

                obj["Chave Vínculo"] = i.chaveVinculo;

                return obj;
            }));
            const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            const dataF = new Blob([excelBuffer], { type: fileType });
            saveAs(dataF, `Relatorio-${Date.now()}` + fileExtension);
        }
    }, [data]);

    useEffect(() => {
        if (show) {
            setLoading(true);
            loadData(0);
        }
    }, [show, loadData]);

    return (
        <Modal size='lg' centered={true} show={show} onHide={toggleModal}>
            <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                <div className="modal-header">
                    <h5 className="modal-title titulo-modal" style={{ textTransform: 'uppercase' }}>Conciliados</h5>
                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                        <i onClick={toggleModal} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                    </div>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-md-12">
                            {!loading && data && data.length > 0 && (
                                <>
                                    <div className="col-md-12 mb-2">
                                        <button type="button" className='btn btn-success' onClick={exportExcel}>Exportar Excel</button>
                                    </div>
                                    <div className="col-md-12 mb-8">
                                        <button type="button" onClick={() => onClickDesvincularTodos(Object.keys(groupBy(data, 'chaveVinculo')))} className="btn btn-danger">Desvincular Todos</button>
                                    </div>
                                </>
                            )}
                            {loading && <label>Carregando...</label>}
                            {(!data || data.length === 0) && !loading && (
                                <label>Não foi encontrado nenhum lançamento</label>
                            )}
                            {data && data.length > 0 && !loading && (
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.keys(groupBy(data, 'chaveVinculo')).map((item) => (
                                            <>
                                                <tr key={uniqueId()}>
                                                    <th scope="row"><button type="button" onClick={() => onClickDesvincular(item)} className="btn btn-danger">Desvincular</button></th>
                                                    <th scope="row">
                                                        <tr>
                                                            <table className="table table-striped">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">Data Lançamento</th>
                                                                        <th>Histórico</th>
                                                                        <th>Tipo</th>
                                                                        <th>Valor</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {data.filter(f => f.chaveVinculo === item).map((item) => (
                                                                        <>
                                                                            <tr key={uniqueId()}>
                                                                                <th scope="row">{moment(item.dataLancamento).format('DD/MM/YYYY')}</th>
                                                                                <th>{item.historico}</th>
                                                                                <th>{item.tipoLancamento}</th>
                                                                                <th>{item.valorProvisaoRecolher.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</th>
                                                                            </tr>
                                                                        </>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </tr>
                                                    </th>
                                                </tr>
                                                <tr style={{ border: 'none' }}>
                                                    <th></th>
                                                    <th>
                                                        <label>Total Débito: {data && data.filter(f => f.chaveVinculo === item && f.tipoLancamento === 'D').length > 0 ? data.filter(f => f.chaveVinculo === item && f.tipoLancamento === 'D').map(m => m.valorProvisaoRecolher).reduce((a, b) => a + b).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : 'R$ 0,00'} </label>
                                                    </th>
                                                </tr>
                                                <tr style={{ border: 'none' }}>
                                                    <th></th>
                                                    <th>
                                                        <label>Total Crédito: {data && data.filter(f => f.chaveVinculo === item && f.tipoLancamento === 'C').length > 0 ? data.filter(f => f.chaveVinculo === item && f.tipoLancamento === 'C').map(m => m.valorProvisaoRecolher).reduce((a, b) => a + b).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : 'R$ 0,00'}</label>
                                                    </th>
                                                </tr>
                                                <tr style={{ border: 'none' }}>
                                                    <th>

                                                    </th>
                                                    <th><label>Diferença: {Math.abs((data.filter(f => f.chaveVinculo === item && f.tipoLancamento === 'C').length > 0 ? data.filter(f => f.chaveVinculo === item && f.tipoLancamento === 'C').map(m => m.valorProvisaoRecolher).reduce((a, b) => a + b) : 0) - (data.filter(f => f.chaveVinculo === item && f.tipoLancamento === 'D').length > 0 ? data.filter(f => f.chaveVinculo === item && f.tipoLancamento === 'D').map(m => m.valorProvisaoRecolher).reduce((a, b) => a + b) : 0)).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</label></th>
                                                </tr>
                                            </>
                                        ))}
                                        <tr>
                                            <th scope="row">Total: {data.length}</th>
                                        </tr>
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

function ModalAlerta({ mensagens, show, toggleModal }: { mensagens: any[], show: boolean, toggleModal: Function }) {

    return (
        <Modal size='lg' centered={true} show={show} onHide={toggleModal}>
            <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                <div className="modal-header">
                    <h5 className="modal-title titulo-modal" style={{ textTransform: 'uppercase' }}>Alertas</h5>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-md-12">
                            {mensagens.map((item) => {
                                return <p style={{ fontSize: '14px' }}>{ReactHtmlParser(item.mensagem)}</p>
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}


const ModalCard = ({ mensagemSistema, mostrarContaReferencial, empresa, dataI, dataF, toggleModal, show, acc, reprocessar, updateAll, conciliacaoInteligente, processou, contas, updateDescription, esteira, conferencia, onConcluidoClick, showModal }: { toggleModal: () => void, show: boolean, acc: IRelatorio | undefined, contas: IRelatorio[], reprocessar: any, conciliacaoInteligente: boolean | undefined, processou: boolean, updateDescription: Function, dataI: Date, dataF: Date, empresa: number, esteira: number, updateAll: Function, mensagemSistema: any[], conferencia: boolean, mostrarContaReferencial: boolean, onConcluidoClick: Function, showModal: Function }) => {

    const [modal, setModal] = useState<any>({
        show: false,
        acc: acc,
        status: null
    });

    const [modalConciliado, setModalConciliado] = useState<any>({
        show: false,
        acc: acc,
        status: null
    });

    const [modalContasConfirmacao, setModalContasConfirmacao] = useState<any>({
        show: false,
        acc: acc,
        status: null
    });

    const [modalAlertas, setModalAlertas] = useState<any>({
        show: false
    });

    // DEVN3-528: cartão com ao menos um alerta (ex.: conta virada) — usado para destacar o SALDO FINAL.
    const contaTemAlerta = !!acc && (mensagemSistema || []).some((f: any) => f.conta === acc.contaEmpresa);

    const [dataConstancia, setDataConstancia] = useState<IConstanciaResumo | null>();
    const [loadingConstancia, setLoadingConstancia] = useState<boolean>(false);

    const [loadingReport, setLoadingReport] = useState<boolean>(false);

    const [arquivosAnexadosAntesProcessar, setArquivosAnexadosAntesProcessar] = useState<IArquivoCardEsteira[]>([]);
    const [linhaConfig, setLinhaConfig] = useState<number>(1);
    const [mesConfig, setMesConfig] = useState<number>(1);
    const [anoConfig, setAnoConfig] = useState<number>(2023);
    const [tipoArquivoSalario, setTipoArquivoSalario] = useState<number>(1);
    const [tipoImportacaoSalario, setTipoImportacaoSalario] = useState<number>(1);
    const [colaboradorConfig, setColaboradorConfig] = useState<string>("A");
    const [proventoConfig, setProventoConfig] = useState<string>("B");
    const [descontoConfig, setDescontoConfig] = useState<string>("C");

    const [dataColunaConfig, setDataColunaConfig] = useState<string>("A");
    const [valorColunaConfig, setValorColunaConfig] = useState<string>("B");
    const [historicoColunaConfig, setHistoricoColunaConfig] = useState<string>("C");
    const [tipoColunaConfig, setTipoColunaConfig] = useState<string>("D");
    const [arquivosAnexados, setArquivoAnexados] = useState<IArquivoCard[]>([]);
    const [loadingFile, setLoadingFile] = useState<boolean>();
    const [loadingList, setLoadingList] = useState<boolean>();

    const [description, setDescription] = useState<string>(acc?.descricao || "");

    const getSistema = useCallback((type: number) => {
        if (type === 1) return "padrao";
        if (type === 2) return "dominio";
        if (type === 3) return "dominio-web"
        return "";
    }, []);

    const loadData = useCallback(async () => {
        if ((empresa === 0 || empresa) && dataI && dataF && acc) {
            setLoadingConstancia(true);
            try {
                const resultado = await ConstanciaService.obterResumo(acc.esteiraID, acc.contaEmpresa);
                if (resultado) {
                    setDataConstancia(resultado);
                } else {
                    setDataConstancia(null)
                }
            } finally {
                setLoadingConstancia(false);
            }
        }
    }, [acc, dataF, dataI, empresa]);
    const { t } = useTranslation();
    const onChangeFile = useCallback(async (e: any) => {
        setLoadingFile(true);
        if (e.target.files !== null && e.target.files.length > 0) {
            const file = e.target.files[0] as File;

            if (acc?.isBanco) {
                if (!file.type.toLowerCase().includes("xls") || !file.type.toLowerCase().includes("ofx")) {
                    if (file.type.toLowerCase().includes("xls")) {
                        if (!dataColunaConfig || !valorColunaConfig || !tipoColunaConfig || !historicoColunaConfig) {
                            Swal.fire({
                                text: t('Por favor preencha todas configurações necessárias para a configuração do arquivo excel.'),
                                timer: 3000,
                                icon: 'error',
                                showConfirmButton: false
                            });
                            return;
                        }
                    }
                } else {
                    Swal.fire({
                        text: t('Por favor para banco importe apenas arquivos excel ou ofx, caso seja um arquivo ofx e não esteja com a extensão, edite o nome do arquivo para nome.ofx'),
                        timer: 5000,
                        icon: 'error',
                        showConfirmButton: false
                    });
                    return;
                }
            }
            const s3 = new ReactS3Client(configBucket);
            const res = await s3.uploadFile(file);

            const result = await ArquivoEmpresaService.cadastrarArquivoCard({
                codigoContabil: acc?.contaEmpresa || '',
                esteiraID: esteira,
                nome: file.name,
                url: res.location,
                id: 0
            });

            setArquivosAnexadosAntesProcessar((old) => {
                const copy = [...old];
                copy.push({
                    esteiraId: esteira,
                    codigoContabil: acc?.contaEmpresa || '',
                    nome: file.name,
                    url: res.location,
                    id: result.id,
                    podeDeletar: true,
                    excelConfigLiquido: {
                        linha: linhaConfig ? linhaConfig.toString() : "0",
                        fornecedor: colaboradorConfig || "",
                        valor: valorColunaConfig || "",
                        mes: mesConfig || 0,
                        ano: anoConfig || 0,
                        sistema: tipoImportacaoSalario === 1 ? "padrao" : "dominio",
                        tipoLiquido: tipoArquivoSalario === 1 ? "Liquido" : "Resumo"
                    },
                    lancamentoConfigExcel: {
                        data: dataColunaConfig,
                        valor: valorColunaConfig,
                        historico: historicoColunaConfig,
                        tipo: tipoColunaConfig
                    },
                    excelConfigResumo: {
                        linha: linhaConfig ? linhaConfig.toString() : "1",
                        evento: colaboradorConfig || "",
                        provento: proventoConfig || "",
                        desconto: descontoConfig || "",
                        mes: mesConfig || 0,
                        ano: anoConfig || 0,
                        sistema: getSistema(tipoImportacaoSalario),
                        tipoLiquido: tipoArquivoSalario === 1 ? "Liquido" : "Resumo"
                    },
                    sistema: getSistema(tipoImportacaoSalario),
                    tipoLiquido: tipoArquivoSalario === 1 ? "Liquido" : "Resumo"
                });
                return copy;
            });
        }
        setLoadingFile(false);
    }, [acc, esteira, dataColunaConfig, getSistema, tipoImportacaoSalario, valorColunaConfig, tipoColunaConfig, linhaConfig, historicoColunaConfig, proventoConfig, descontoConfig, anoConfig, mesConfig, tipoArquivoSalario, colaboradorConfig, valorColunaConfig]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    useEffect(() => {
        if (!show) {
            setArquivosAnexadosAntesProcessar([]);
            setLoadingFile(false);
        }
    }, [show]);

    useEffect(() => {
        if (acc && esteira) {
            setLoadingFile(true);
            ArquivoEmpresaService.liscarArquivoCard(acc?.contaEmpresa || "", esteira).then((resp) => {
                setLoadingFile(false);
                setArquivoAnexados(resp);
            });
        }
    }, [acc, esteira]);

    useEffect(() => {
        if (acc && acc.descricao) {
            setDescription(acc.descricao);
        } else {
            setDescription("");
        }
    }, [acc?.descricao])


    return (
        <>
            <ModalAlerta mensagens={mensagemSistema.filter(f => f.conta === acc?.contaEmpresa)} show={modalAlertas.show} toggleModal={() => setModalAlertas({ show: false })} />
            <RelatorioDemonstracaoContasConciliadas id={acc?.id || 0} esteiraID={acc?.esteiraID || 0} show={modalConciliado.show} acc={modalConciliado.acc} toggleModal={() => {
                setModalConciliado({
                    show: false,
                    acc: acc,
                    status: null
                })
            }} />
            <RelatorioDemonstracaoContasConfirmacao id={acc?.id || 0} esteiraID={acc?.esteiraID || 0} show={modalContasConfirmacao.show} acc={modalContasConfirmacao.acc} toggleModal={() => {
                setModalContasConfirmacao({
                    show: false,
                    acc: acc,
                    status: null
                })
            }} />
            <RelatorioDemonstracaoContas contas={contas} esteiraID={acc?.esteiraID || 0} show={modal.show} id={modal.acc?.id || 0} status={modal.status} toggleModal={() => {
                setModal({
                    show: false,
                    acc: acc,
                    status: null
                })
            }} />
            <Modal size='lg' centered={true} show={modal.show || modalConciliado.show || modalContasConfirmacao.show ? false : show} onHide={toggleModal}>
                <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                    <div className="modal-header">
                        <h5 className="modal-title titulo-modal">{acc?.contaEmpresa} - {acc?.descricaoEmpresa || acc?.descricaoReferencial}</h5>
                        <br />
                        <h5 className="modal-title titulo-modal" style={{ fontSize: '10px' }}>{acc?.contaReferencial} - {acc?.descricaoReferencial}</h5>
                        <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                            <i onClick={toggleModal} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                        </div>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-md-8">
                                <div className="row">
                                    <div className='col-md-12'>
                                        {acc && (
                                            <div className='row'>
                                                <div className="col-md-6">
                                                    <p className="h6" style={{ color: 'gray' }}>{t("SALDO INICIAL: ")}</p>
                                                </div>
                                                <div className="col-md-6">
                                                    <p className="h6">{acc.saldoInicial.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} {acc.lancamentoInicial}</p>
                                                </div>
                                                <div className="col-md-6 mt-2">
                                                    <p className="h6" style={{ color: 'gray' }}>{t("MOVIMENTAÇÃO DÉBITO:")} </p>
                                                </div>
                                                <div className="col-md-6 mt-2">
                                                    <p className="h6">{acc.debito.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
                                                </div>
                                                <div className="col-md-6 mt-2">
                                                    <p className="h6" style={{ color: 'gray' }}>{t("MOVIMENTAÇÃO CRÉDITO:")} </p>
                                                </div>
                                                <div className="col-md-6 mt-2">
                                                    <p className="h6">{acc.credito.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
                                                </div>
                                                <div className="col-md-6 mt-2">
                                                    <p className="h6" style={{ color: (acc.erroSaldoFinal || contaTemAlerta) ? '#C0392B' : 'gray', fontWeight: (acc.erroSaldoFinal || contaTemAlerta) ? 'bold' : undefined }}>{t("SALDO FINAL:")} </p>
                                                </div>
                                                <div className="col-md-6 mt-2">
                                                    <p className="h6" style={{ color: (acc.erroSaldoFinal || contaTemAlerta) ? '#C0392B' : 'unset', fontWeight: (acc.erroSaldoFinal || contaTemAlerta) ? 'bold' : undefined }}>{acc.saldoFinalReal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} {acc.lancamento}</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    {loadingConstancia ? (
                                        <div className="col-md-12 mt-6 text-center">
                                            <div className="spinner-border text-success" role="status" style={{ margin: '0 auto' }}>
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            {dataConstancia && dataConstancia.padrao && (
                                                <div className="col-md-12 mt-6">
                                                    <p className="h6" style={{ color: 'gray' }}>{t("PADRÃO IDENTIFICADO:")} </p>
                                                    <p className="h6">
                                                        {dataConstancia.padrao.historicoPadrao} — {dataConstancia.padrao.valorPadrao.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                                                    </p>
                                                </div>
                                            )}

                                            {dataConstancia && dataConstancia.consolidadoMensal && dataConstancia.consolidadoMensal.length > 0 && (
                                                <div className="col-md-12 mt-6">
                                                    <Line options={options} data={{
                                                        labels: dataConstancia.consolidadoMensal.map((item) => `${item.mes.toString().padStart(2, '0')}/${item.ano}`),
                                                        datasets: [
                                                            {
                                                                label: 'R$',
                                                                data: dataConstancia.consolidadoMensal.map((item) => item.valor),
                                                                borderColor: 'rgba(41, 128, 185,1.0)',
                                                                backgroundColor: 'rgba(41, 128, 185,0.5)',
                                                            },
                                                        ],
                                                    }} />
                                                </div>
                                            )}

                                            {dataConstancia && dataConstancia.consolidadoMensal && dataConstancia.consolidadoMensal.length > 0 && (
                                                <div className="col-md-12 mt-2">
                                                    <Line options={options} data={{
                                                        labels: dataConstancia.consolidadoMensal.map((item) => `${item.mes.toString().padStart(2, '0')}/${item.ano}`),
                                                        datasets: [
                                                            {
                                                                label: '%',
                                                                data: (() => {
                                                                    const totalPeriodo = dataConstancia.consolidadoMensal.reduce((soma, item) => soma + Math.abs(item.valor), 0);
                                                                    return dataConstancia.consolidadoMensal.map((item) => totalPeriodo > 0 ? (Math.abs(item.valor) / totalPeriodo) * 100 : 0);
                                                                })(),
                                                                borderColor: 'rgb(0,183,161)',
                                                                backgroundColor: 'rgba(0,183,161, 0.5)',
                                                            },
                                                        ],
                                                    }} />
                                                </div>
                                            )}

                                            {dataConstancia && dataConstancia.previsao && dataConstancia.previsao.some((p) => p.possuiErro) && (
                                                <div className="col-md-12 mt-6">
                                                    <p className="h6" style={{ color: 'gray' }}>{t("MESES FORA DO PADRÃO:")} </p>
                                                    <ul>
                                                        {dataConstancia.previsao.filter((p) => p.possuiErro).map((p, index) => (
                                                            <li key={index}>
                                                                {p.mes.toString().padStart(2, '0')}/{p.ano} — {p.observacao}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </>
                                    )}
                                    <div className="col-md-12 mt-6">
                                        <div className="form-group">
                                            <label className="h5">Descrição</label>
                                            <textarea value={description} maxLength={255} onChange={(e) => setDescription(e.target.value)} onBlur={() => updateDescription(description)} style={{ backgroundColor: 'transparent' }} className="form-control" placeholder={t("Adicione uma descrição")}></textarea>
                                        </div>
                                    </div>
                                    <div className="col-md-12 mt-5">
                                        <label className="h5">Anexos</label>
                                    </div>
                                    <div className="col-md-12 mt-2 mb-2">
                                        {acc && (acc.isBanco) && (
                                            <div className="row">
                                                <h5>Configuração para o arquivo a ser importado (apenas válido para arquivo excel)</h5>
                                                <div className='col-md-3 form-group'>
                                                    <label>Coluna Data (A)</label>
                                                    <input value={dataColunaConfig} onChange={(e) => setDataColunaConfig(e.target.value)} type='text' className='form-control' />
                                                </div>
                                                <div className='col-md-3 form-group'>
                                                    <label>Coluna Valor (B)</label>
                                                    <input value={valorColunaConfig} onChange={(e) => setValorColunaConfig(e.target.value)} type='text' className='form-control' />
                                                </div>
                                                <div className='col-md-3 form-group'>
                                                    <label>Coluna Historico (C)</label>
                                                    <input type='text' className='form-control' value={historicoColunaConfig} onChange={(e) => setHistoricoColunaConfig(e.target.value)} />
                                                </div>
                                                <div className='col-md-3 form-group'>
                                                    <label>Coluna Tipo (D)</label>
                                                    <input type='text' className='form-control' value={tipoColunaConfig} onChange={(e) => setTipoColunaConfig(e.target.value)} />
                                                </div>
                                            </div>
                                        )}
                                        {acc && (acc.isSalario) && (
                                            <div className="row">
                                                <div className='col-md-12 mt-2'>
                                                    <h5>Configuração para o arquivo a ser importado (apenas válido para arquivo excel)</h5>
                                                </div>
                                                <div className='col-md-12 form-group mt-1'>
                                                    <label>Selecione um template de importação</label>
                                                    <select className='form-control' value={tipoImportacaoSalario} onChange={(e) => setTipoImportacaoSalario(parseInt(e.target.value))}>
                                                        <option value={1}>Padrão Agholmes</option>
                                                        <option value={2}>Domínio</option>
                                                        <option value={3}>Domínio Web</option>
                                                    </select>
                                                </div>
                                                <div className='col-md-12 form-group mt-1'>
                                                    <label>Selecione um tipo</label>
                                                    <select className='form-control' value={tipoArquivoSalario} onChange={(e) => setTipoArquivoSalario(parseInt(e.target.value))}>
                                                        <option value={1}>Líquido</option>
                                                        <option value={2}>Resumo</option>
                                                    </select>
                                                </div>
                                                {tipoImportacaoSalario === 1 && (
                                                    <>
                                                        {tipoArquivoSalario === 1 && (
                                                            <>
                                                                <div className='col-md-3 form-group mt-1'>
                                                                    <label>Linha Inicial</label>
                                                                    <input value={linhaConfig} onChange={(e) => setLinhaConfig(parseInt(e.target.value))} type='number' className='form-control' />
                                                                </div>
                                                                <div className='col-md-3 form-group mt-1'>
                                                                    <label>Coluna Nome (A)</label>
                                                                    <input value={colaboradorConfig} onChange={(e) => setColaboradorConfig(e.target.value)} type='text' className='form-control' />
                                                                </div>
                                                                <div className='col-md-3 form-group mt-1'>
                                                                    <label>Coluna Valor (B)</label>
                                                                    <input value={valorColunaConfig} onChange={(e) => setValorColunaConfig(e.target.value)} type='text' className='form-control' />
                                                                </div>
                                                                <div className='col-md-3 form-group mt-1'>
                                                                    <label>Mês</label>
                                                                    <input type='number' className='form-control' value={mesConfig} onChange={(e) => setMesConfig(parseInt(e.target.value))} />
                                                                </div>
                                                                <div className='col-md-3 form-group mt-1'>
                                                                    <label>Ano</label>
                                                                    <input type='number' className='form-control' value={anoConfig} onChange={(e) => setAnoConfig(parseInt(e.target.value))} />
                                                                </div>
                                                            </>
                                                        )}

                                                        {(tipoArquivoSalario === 2 || tipoArquivoSalario === 3) && (
                                                            <>
                                                                <div className='col-md-3 form-group mt-1'>
                                                                    <label>Linha Inicial</label>
                                                                    <input value={linhaConfig} onChange={(e) => setLinhaConfig(parseInt(e.target.value))} type='number' className='form-control' />
                                                                </div>
                                                                <div className='col-md-3 form-group mt-1'>
                                                                    <label>Coluna Evento (A)</label>
                                                                    <input value={colaboradorConfig} onChange={(e) => setColaboradorConfig(e.target.value)} type='text' className='form-control' />
                                                                </div>
                                                                <div className='col-md-3 form-group mt-1'>
                                                                    <label>Coluna Provento (B)</label>
                                                                    <input value={proventoConfig} onChange={(e) => setProventoConfig(e.target.value)} type='text' className='form-control' />
                                                                </div>
                                                                <div className='col-md-3 form-group mt-1'>
                                                                    <label>Coluna Desconto (C)</label>
                                                                    <input value={descontoConfig} onChange={(e) => setDescontoConfig(e.target.value)} type='text' className='form-control' />
                                                                </div>
                                                                <div className='col-md-3 form-group mt-1'>
                                                                    <label>Mês</label>
                                                                    <input type='number' className='form-control' value={mesConfig} onChange={(e) => setMesConfig(parseInt(e.target.value))} />
                                                                </div>
                                                                <div className='col-md-3 form-group mt-1'>
                                                                    <label>Ano</label>
                                                                    <input type='number' className='form-control' value={anoConfig} onChange={(e) => setAnoConfig(parseInt(e.target.value))} />
                                                                </div>
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        )}
                                        {loadingList && <p className="mt-2">Carregando</p>}
                                        {(!loadingList && (!arquivosAnexadosAntesProcessar || arquivosAnexadosAntesProcessar.length <= 0) && (!arquivosAnexados || arquivosAnexados.length <= 0)) && <label className="mt-2">{t("Nenhum anexo foi encontrado")}</label>}
                                        {!loadingList && arquivosAnexadosAntesProcessar.map((item, idx) => (
                                            <div key={uniqueId()} style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }} className='mt-2'>
                                                <i className='fa fa-paperclip fs-4' />
                                                <p style={{ margin: 0, marginLeft: '10px' }}>{item.nome}</p>
                                                {<button onClick={() => {
                                                    ArquivoEmpresaService.removerArquivoCard(item.id);
                                                    setArquivosAnexadosAntesProcessar((old) => {
                                                        let copy = [...old] || [];
                                                        copy.splice(idx, 1);
                                                        return copy;
                                                    });
                                                }} style={{ background: 'transparent', border: 'none', marginLeft: '10px' }}>Excluir</button>}
                                            </div>
                                        ))}
                                        {!loadingList && arquivosAnexados.map((item, idx) => (
                                            <div key={uniqueId()} style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }} className='mt-2'>
                                                <i className='fa fa-paperclip fs-4' />
                                                <p onClick={() => window.open(item.url)} style={{ margin: 0, marginLeft: '10px' }}>{item.nome}</p>
                                                {<button onClick={() => {
                                                    ArquivoEmpresaService.removerArquivoCard(item.id);
                                                    setArquivoAnexados((old) => {
                                                        let copy = [...old] || [];
                                                        copy.splice(idx, 1);
                                                        return copy;
                                                    });


                                                }} style={{ background: 'transparent', border: 'none', marginLeft: '10px' }}>Excluir</button>}
                                            </div>
                                        ))}
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <label>Selecione um arquivo para importar</label>
                                        {loadingFile ? <p>Carregando...</p> : (
                                            <div className="form-group mt-2">
                                                <input type='file' placeholder='Anexar...' accept='*' onChange={(e) => onChangeFile(e)} className="form-control" />
                                            </div>)
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="row">
                                    <div className="col-md-12 mt-2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
                                        {loadingReport ? (
                                            <div className="spinner-border text-success" role="status" style={{ marginBottom: '5px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        ) : (
                                            <>
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }} onClick={(e) => {
                                                    setLoadingReport(true);
                                                    RelatoriosService.pegarUrlImpressaoNovo(empresa, [[{
                                                        conta: acc?.contaEmpresa || '',
                                                        id: acc?.id || 0
                                                    }]], mostrarContaReferencial, dataI, dataF, (x) => {
                                                        setLoadingReport(false);
                                                        window.open(URL.createObjectURL(x), '_blank');
                                                    });
                                                }}>
                                                    <i className='fa fa-eye fs-4' style={{ color: 'gray', fontSize: '24px' }} />
                                                    <p>Visualizar</p>
                                                </div>
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '30px', textAlign: 'center' }} onClick={(e) => {
                                                    RelatoriosService.pedirRelatorioImpressaoLancamentos(esteira, acc?.contaEmpresa || '');
                                                    Swal.fire({
                                                        text: t('Seu download foi solicitado e após concluído você receberá uma notificação e será enviado em seu e-mail.'),
                                                        timer: 5000,
                                                        icon: 'success',
                                                        showConfirmButton: false
                                                    });
                                                }}>
                                                    <i className='fa fa-file fs-4' style={{ color: 'gray', fontSize: '24px' }} />
                                                    <p>Baixar Lançamentos</p>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                    {
                                        conferencia && (
                                            <div className="col-md-12 mt-2">
                                                <button onClick={() => onConcluidoClick()} type="button" className="btn btn-default me-5" style={{ width: '100%', backgroundColor: '#E1E4E9' }}>MOVER PARA CONCLUÍDO</button>
                                            </div>
                                        )
                                    }
                                    {
                                        conciliacaoInteligente && (
                                            <div className="col-md-12 mt-2">
                                                <button onClick={toggleModal} type="button" className="btn btn-default me-5" style={{ width: '100%', backgroundColor: '#E1E4E9' }}>CONCILIAÇÃO INTELIGENTE</button>
                                            </div>
                                        )
                                    }
                                    {
                                        reprocessar && (
                                            <div className="col-md-12 mt-2">
                                                <button onClick={() => reprocessar(arquivosAnexadosAntesProcessar)} type="button" className="btn btn-default me-5" style={{ width: '100%', backgroundColor: '#E1E4E9' }}>PROCESSAR</button>
                                            </div>
                                        )
                                    }
                                    <div className="col-md-12 mt-2">
                                        <button onClick={() => {
                                            setModalAlertas({ show: true });
                                        }} type="button" className="btn btn-default me-5" style={{ width: '100%', backgroundColor: '#E1E4E9' }}>ALERTAS</button>
                                    </div>
                                    {acc && acc?.status && acc.status !== "Pendentes" && acc.status !== "Em processamento" && (
                                        <div className="col-md-12 mt-2">
                                            <button onClick={() => {
                                                if (acc.isBanco || acc.isSalario || acc.isFornecedor) {
                                                    let anexosFix: IArquivoCardEsteira[] = [];
                                                    if (arquivosAnexadosAntesProcessar && arquivosAnexadosAntesProcessar.length > 0) {
                                                        arquivosAnexadosAntesProcessar.forEach(f => {
                                                            anexosFix.push(f);
                                                        });
                                                    }

                                                    if (arquivosAnexados && arquivosAnexados.length > 0) {
                                                        arquivosAnexados.forEach(f => {
                                                            anexosFix.push({
                                                                codigoContabil: acc.contaEmpresa,
                                                                esteiraId: acc.esteiraID,
                                                                nome: f.nome,
                                                                url: f.url
                                                            } as IArquivoCardEsteira);
                                                        });
                                                    }

                                                    RelatoriosService.lancarParaProcessamento(esteira, [acc.contaEmpresa], anexosFix, false, []);
                                                    RelatoriosService.updateStatusConta(acc.contaEmpresa, esteira || 0, "Em processamento");
                                                    updateAll(acc.contaEmpresa, "Em processamento");
                                                    toggleModal();
                                                }
                                                else {
                                                    RelatoriosService.lancarParaProcessamento(esteira, [acc.contaEmpresa], [], false, []);
                                                    RelatoriosService.updateStatusConta(acc.contaEmpresa, esteira || 0, "Em processamento");
                                                    updateAll(acc.contaEmpresa, "Em processamento");
                                                    toggleModal();
                                                }
                                            }} type="button" className="btn btn-default me-5" style={{ width: '100%', backgroundColor: '#E1E4E9' }}>REPROCESSAR</button>
                                        </div>
                                    )}
                                    {
                                        processou ? Object.keys(statusObject).map((item) => (
                                            <div className="col-md-12 mt-2" key={uniqueId()}>
                                                <button onClick={() => {
                                                    if (item === 'conciliado') {
                                                        setModalConciliado({
                                                            show: true,
                                                            acc: acc?.contaEmpresa,
                                                            status: item
                                                        })
                                                    } else if (item === 'possiveisMatch') {
                                                        setModalContasConfirmacao({
                                                            show: true,
                                                            acc: acc?.contaEmpresa,
                                                            status: item
                                                        })
                                                    } else {
                                                        setModal({
                                                            show: true,
                                                            acc: acc?.contaEmpresa,
                                                            status: item
                                                        })
                                                    }
                                                }} type="button" className="btn btn-default me-5" style={{ width: '100%', backgroundColor: '#E1E4E9' }}>{statusObject[item]}</button>
                                            </div>
                                        )) : (
                                            <div className="spinner-border text-success" role="status" style={{ margin: '0 auto', marginTop: '20px' }}>
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default ModalCard;